export default "__VITE_ASSET__CVAGdpaq__"